
<template>
  <v-container
      :style="loginPageBackground"
      class="background-img"
      fluid
  >
    <v-row
        align="center"
        class="text-center d-flex flex-column"
    >
      <v-col cols="10" md="7">
        <v-card
            :style="cardStyle"
            class="d-flex flex-column"
            elevation="24"
        >
          <v-card-text class="px-0 py-0">
            <v-row class="loginContent justify-center">

              <!-- Right Side (Login Form) -->
              <v-col
                  :style="loginRightBackground"
                  cols="12"
                  sm="6"
              >
                <h1
                    :style="loginTitleStyle"
                    class="my-10 py-5"
                >
                  {{ $t("SYSTEM_NAME") }}
                </h1>

                <h2
                    :style="loginSubtitleStyle"
                    class="my-10"
                >
                  {{ $t("LOGIN") }}
                </h2>

                <div class="px-7">
                  <v-form
                      ref="form"
                      @submit.prevent="login"
                  >

                    <v-text-field
                        v-model.trim="userData.username"
                        :placeholder="$t('USERNAME_EMAIL')"
                        :prepend-inner-icon="usernameIcon"
                        :rules="usernameRules"
                        background-color="white"
                        class="InputLogin"
                        dense
                        maxlength="70"
                        outlined
                    />

                    <v-text-field
                        v-model="userData.password"
                        :placeholder="$t('PASSWORD')"
                        :prepend-inner-icon="passwordIcon"
                        :rules="passwordRules"
                        background-color="white"
                        dense
                        maxlength="20"
                        outlined
                        type="password"
                    />

                    <v-row class="text-center">
                      <v-col cols="12">
                        <v-btn
                            :style="loginButtonStyle"
                            class="title align-center login-btn"
                            depressed
                            large
                            @click="login"
                        >
                          {{ $t("LOGIN") }}
                        </v-btn>
                      </v-col>
                    </v-row>

                    <v-row class="mt-5">

                      <v-col
                          class="d-flex justify-lg-start"
                          cols="12"
                          md="4"
                      >
                        <v-btn
                            :style="linkStyle"
                            small
                            text
                            @click="register()"
                        >
                          <v-icon class="mx-1" small>
                            {{ registerIcon }}
                          </v-icon>

                          {{ $t("REGISTER") }}
                        </v-btn>
                      </v-col>

                      <v-col
                          class="d-flex justify-lg-end"
                          cols="12"
                          md="8"
                      >
                        <v-btn
                            :style="linkStyle"
                            small
                            text
                            @click="forgotPassword"
                        >
                          <v-icon class="mx-1" small>
                            {{ forgotPasswordIcon }}
                          </v-icon>

                          {{ $t("FORGOT_PASSWORD") }}
                        </v-btn>
                      </v-col>

                      <v-col
                          class="d-flex justify-lg-end"
                          cols="12"
                          md="8"
                      >
                        <v-btn
                            :style="linkStyle"
                            class="px-0 py-0"
                            small
                            text
                            @click="resetEmail"
                        >
                          {{ $t("UPDATE_MAIL_TO_ACTIVATE") }}
                        </v-btn>
                      </v-col>

                    </v-row>

                    <!-- Dynamic Divider -->
                    <div
                        :style="dividerContainerStyle"
                        class="admission-divider"
                    >
  <span
      :style="dividerLineStyle"
      class="divider-line"
  ></span>

                      <v-icon
                          :color="dividerColor"
                          size="28"
                      >
                        {{ dividerIcon }}
                      </v-icon>

                      <span
                          :style="dividerLineStyle"
                          class="divider-line"
                      ></span>
                    </div>

                    <ad-alerts
                        :error="serverTranslate(error)"
                        :snackbar="snackbar"
                    />

                  </v-form>
                </div>
              </v-col>

              <!-- Left Side -->
              <v-col
                  :style="loginLeftBackground"
                  class="justify-end yasmeen"
                  cols="12"
                  sm="6"
              >
                <div class="pa-5">
                  <div  class="logo-wrapper">
                    <img
                      v-if="universityLogo && universityLogo.length > 0"
                      :src="universityLogo"
                      :style="logoImageSize"
                      alt=""
                      class="university-logo"
                    />
                  </div>

                  <div
                      :style="leftTextStyle"
                      class="display-1 my-3"
                  >
                    {{ serverTranslate($store.state.title) }}
                  </div>
                  <div class="left-subtitle">
                    {{ $t("ADMISSION_GATE") }}

                  </div>

                  <div class="left-divider">
                    <span class="left-divider-line"></span>
                    <span class="left-divider-dot"></span>
                    <span class="left-divider-line"></span>
                  </div>

                  <p class="my-10"></p>

                  <v-carousel
                      v-if="news.length"
                      :cycle="false"
                      height="170"
                      hide-delimiter-background
                      reverse-transition="fade-transition"
                      transition="fade-transition"
                  >
                    <v-carousel-item
                        v-for="(newItem, index) in news"
                        :key="index"
                    >
                      <div class="flex-column flex-row">
                        <div
                            :style="leftTextStyle"
                            v-html="serverTranslate(newItem.new_full_text)"
                        ></div>
                      </div>
                    </v-carousel-item>
                  </v-carousel>

                  <p>
                    <a
                        v-if="allNewsUrl !== ''"
                        :href="allNewsUrl"
                        :style="leftTextStyle"
                        class="v-btn v-btn--depressed v-btn--flat v-btn--outlined theme--light v-size--default primary--text ma-2 px-10"
                        target="_blank"
                    >
                      {{ $t("ALL_NEWS") }}
                    </a>
                  </p>

                  <p
                      v-if="termsFilePath && termsFilePath !== ''"
                  >
                    <button
                        :style="leftTextStyle"
                        @click="downloadTerms"
                    >
                      {{ $t("ADMISSION_DATA.STEP3.ADMISSION_TERMS") }}
                    </button>
                  </p>

                  <div
                      :style="leftTextStyle"
                      class="d-flex align-center justify-center mt-4"
                  >
                    <v-icon
                        :color="linkColor"
                        class="mx-1"
                        small
                    >
                      {{ languageIcon }}
                    </v-icon>

                    <ad-changeLanguage
                        :primaryColor="true"
                        showTooltip="false"
                        v-on:swichLanguage="onLanguageChanged"
                    />
                  </div>

                </div>
              </v-col>

            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <ad-forgotPassword ref="forgotPassword"/>
    <ad-ResetMail ref="ResetMail"/>
  </v-container>
</template>

<style>
.logo-wrapper {
  height: 120px;              /* نفس المساحة اللي عايزاها للصورة */
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.university-logo {
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
  display: block;
}
.left-subtitle {
    color: #d9b35a;
    font-size: 24px;
    font-weight: 500;
    margin-top: 10px;
    text-align: center;
}

.left-divider {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
    margin-bottom: 25px;
}

.left-divider-line {
    width: 70px;
    height: 2px;
    background: #d9b35a;
}

.left-divider-dot {
    width: 8px;
    height: 8px;
    background: #d9b35a;
    border-radius: 50%;
    margin: 0 10px;
}

</style>
<script>
import ChangeLanguage from "@/components/layout/ChangeLanguage";
import ForgotPassword from "@/components/LoginComponent/ForgotPassword";
import Alerts from "@/components/layout/Alerts";
import store from "@/store";
import serverTranslationsMixin from "@/mixins/serverTranslations.js";
import ResetMail from "@/components/LoginComponent/resetMailComponent"

export default {
  components: {
    "ad-changeLanguage": ChangeLanguage,
    "ad-forgotPassword": ForgotPassword,
    "ad-alerts": Alerts,
    "ad-ResetMail": ResetMail,
  },
  mixins: [serverTranslationsMixin],
  mounted() {
    this.$refs.form.resetValidation();
    const backgroundImage = localStorage.getItem("backgroundImage");
    const backgroundElement = document.querySelector('.background-img');
    // Set the background image dynamically
    backgroundElement.style.backgroundImage = `url(${backgroundImage})`;
    backgroundElement.style.backgroundPosition = "center";
    backgroundElement.style.backgroundSize = "cover";
    backgroundElement.style.backgroundRepeat = "no-repeat";
    this.getNews();
  },
  computed: {
    resetMailIcon() {
  return localStorage.getItem(
      "loginResetMailIcon"
  ) || "mdi-email-sync-outline";
},
    linkColor() {
      return (
          localStorage.getItem("loginLinkColor")
          || "#16B5C3"
      );
    },
    usernameIcon() {
      return localStorage.getItem(
          "loginUsernameIcon"
      ) || "mdi-account-outline";
    },

    passwordIcon() {
      return localStorage.getItem(
          "loginPasswordIcon"
      ) || "mdi-lock-outline";
    },

    registerIcon() {
      return localStorage.getItem(
          "loginRegisterIcon"
      ) || "mdi-account-plus-outline";
    },

    forgotPasswordIcon() {
      return localStorage.getItem(
          "loginForgotPasswordIcon"
      ) || "mdi-lock-reset";
    },

    languageIcon() {
      return localStorage.getItem(
          "loginLanguageIcon"
      ) || "mdi-web";
    },
    dividerIcon() {
      return localStorage.getItem(
          "loginDividerIcon"
      ) || "mdi-school";
    },

    dividerColor() {
      return localStorage.getItem(
          "loginDividerColor"
      ) || "#D9B35A";
    },

    dividerLineStyle() {
      return `
        width:${
          localStorage.getItem(
              "loginDividerWidth"
          ) || "120px"
      };
        height:1px;
        background:${
          localStorage.getItem(
              "loginDividerColor"
          ) || "#D9B35A"
      };
        margin:0 15px;
    `;
    },

    dividerContainerStyle() {
      return `
        display:flex;
        align-items:center;
        justify-content:center;
        margin-top:30px;
        margin-bottom:20px;
    `;
    },

    cardStyle() {
      return `
          border-radius:24px;
          overflow:hidden;
          box-shadow:${
          localStorage.getItem("loginCardShadow")
          || "0 20px 50px rgba(0,0,0,.08)"
      };
      `;
    },

    linkStyle() {
      return `
          color:${
          localStorage.getItem("loginLinkColor")
          || "#16B5C3"
      };
      `;
    },

    leftTextStyle() {
      return `
          color:${
          localStorage.getItem("loginLeftText")
          || "#FFFFFF"
      };
      `;
    },

    loginPageBackground() {
      return `
          background-color:${
          localStorage.getItem("loginPageBackground")
          || "#F5F8FC"
      };
      `;
    },

    loginLeftBackground() {
      return `
          background:${
          localStorage.getItem("loginLeftBackground")
          || "#0B2D6B"
      };
      `;
    },

    loginRightBackground() {
      return `
          background:${
          localStorage.getItem("loginRightBackground")
          || "#FFFFFF"
      };
      `;
    },

    loginTitleStyle() {
      return `
          color:${
          localStorage.getItem("loginTitleColor")
          || "#0B2D6B"
      };
      `;
    },

    loginSubtitleStyle() {
      return `
          color:${
          localStorage.getItem("loginSubtitleColor")
          || "#16B5C3"
      };
      `;
    },

    loginButtonStyle() {

      const start =
          localStorage.getItem(
              "loginButtonGradientStart"
          ) || "#12B4C2";

      const end =
          localStorage.getItem(
              "loginButtonGradientEnd"
          ) || "#18A9B7";

      const radius =
          localStorage.getItem(
              "loginButtonBorderRadius"
          ) || "8px";

      const minWidth =
          localStorage.getItem(
              "loginButtonMinWidth"
          ) || "250px";

      const textColor =
          localStorage.getItem(
              "loginButtonTextColor"
          ) || "#FFFFFF";

      return {
        background: `linear-gradient(90deg, ${start}, ${end})`,
        color: textColor,
        borderRadius: radius,
        minWidth: minWidth,
        boxShadow: '0 4px 12px rgba(0,0,0,.15)'
      };
    },


    universityTitle() {
      return this.serverTranslate(this.$store.state.title);
    },
    universityLogo() {
      return this.$store.getters.getUniversityLogo;
    },

    // backgroundColorRight() {
    //   const backgroundColorRight = localStorage.getItem("backgroundColorRight");
    //   const backgroundStyle = (backgroundColorRight != "undefined" && backgroundColorRight ? "background-color:" + backgroundColorRight : "background-color:#FFFFFF")
    //   return backgroundStyle;
    // },
    // fontColorRight() {
    //   const fontColorRight = localStorage.getItem("fontColorRight");
    //   const fontColorStyle = ((fontColorRight != "undefined" && fontColorRight) ? "color:" + fontColorRight : "color:#00afb9;")
    //   return fontColorStyle;
    // } ,
    // backgroundLogin() {
    //   const fontColorRight = localStorage.getItem("fontColorRight");
    //   const backgroundStyle = (fontColorRight != "undefined" && fontColorRight ? "background-color:" + fontColorRight + ";background-size: cover; display: flex;" : "background-color:#00afb9")
    //   return backgroundStyle;
    //
    // },
    // backgroundColorLeft() {
    //   const backgroundColorLeft = localStorage.getItem("backgroundColorLeft");
    //   const backgroundStyle = (backgroundColorLeft != "undefined" && backgroundColorLeft ? "background-color:" + backgroundColorLeft : "background-color:#000000")
    //   return backgroundStyle;
    // },
    // fontColorLeft() {
    //   const fontColorLeft = localStorage.getItem("fontColorLeft");
    //   const fontColorStyle = ((fontColorLeft != "undefined" && fontColorLeft) ? "color:" + fontColorLeft : "color:#FFFFFF;")
    //   return fontColorStyle;
    // },
    // backgroundColorButton() {
    //   const backgroundColorButton = localStorage.getItem("backgroundColorButton");
    //   const backgroundStyle = (backgroundColorButton != "undefined" && backgroundColorButton ? "background-color:" + backgroundColorButton : "background-color:#00afb9 ")
    //   return backgroundStyle;
    // },
    logoImageSize() {
      const logoImageClass = localStorage.getItem("logoImageClass");
      const logoImageStyle = (logoImageClass != "undefined" && logoImageClass ? logoImageClass : " width: 30vh; height: 20vh; ")
      return logoImageStyle

    }
  },
  data() {

    return {
      termsFilePath: localStorage.getItem("termsFilePath"),
      direction: this.$store.state.direction,
      valid: true,
      error: "",
      fontColor: "",
      snackbar: false,
      usernameRules: [
        v => v.length <= 70 || this.$t("USERNAME_MAX"),
        v => !!v || this.$t("USERNAME_REQUIRED")
      ],
      passwordRules: [
        v => v.length <= 20 || this.$t("PASSWORD_MAX"),
        v => !!v || this.$t("PASSWORD_REQUIRED")
      ],
      inset: false,
      userData: {
        username: "",
        password: ""
      },
      news: [],
      allNewsUrl: ''
    };
  },
  methods: {
    downloadTerms() {
      window.open(this.termsFilePath, '_blank');
      // const link = document.createElement('a');
      // link.href = this.termsFilePath;
      // link.download = 'termsFilePath.pdf';
      // link.click();
    },
    getFoundation() {
      return localStorage.getItem("foundationId")
    },
    getNews() {
      this.$http.get("/api/general_data/get_news_data/").then(
          response => {
            this.news = response.data.news;
            this.allNewsUrl = response.data.allNewsLink;
          }
      )

    },
    login() {
      if (this.$refs.form.validate()) {
        this.$http.post("/api/users/login", this.userData).then(
            response => {
              if (response) {
                store.commit("login", {
                  token: response.headers.token,
                  userName: response.data.username,
                  message: response.data.message
                });
                this.$toasted.show(this.serverTranslate(response.data.message), {
                  type: "success",
                  icon: "check_circle_outline",
                  duration: 3000,
                  theme: "bubble",
                  position: "bottom-left"
                });
                this.$router.push("/home");
              }
            },
            err => {
              this.$toasted.show(
                  this.serverTranslate(err.response.data.message),
                  {
                    type: "error",
                    icon: "error_outline",
                    theme: "bubble",
                    position: "bottom-left",
                    duration: 3000
                  }
              );
            }
        );
      }
    },
    onLanguageChanged: function (direction) {
      if (this.$refs.form) {
        if (this.$el) {
          if (this.$el.querySelector(".error--text")) {
            this.$refs.form.validate();
          }
        }
      }
      this.direction = direction;
    },
    register() {
      this.$router.push("/register");
    },
    forgotPassword() {
      this.$refs.forgotPassword.open()
    }, resetEmail() {
      this.$refs.ResetMail.open()
    }
  }
};
</script>
